import { useEffect, useRef, useState } from "react";
import AsyncSelect from "react-select/async";
import { Col } from "reactstrap";

export type SelectItemsProps = {
    label: string;
    value: string;
};

export type SearchOrTypeSelectProps = {
    label: string;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    loadOptions: (value: string) => Promise<SelectItemsProps[]>;
    onChange: (value: SelectItemsProps | null) => void;
    value: SelectItemsProps | null;
    isDisabled?: boolean;
    style?: React.CSSProperties;
};

function SearchOrTypeSelectComponent(props: SearchOrTypeSelectProps) {
    const [inputValue, setInputValue] = useState<string>(props.value?.label || "");
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleLoadOptions = (inputValue: string): Promise<SelectItemsProps[]> => {
        return new Promise((resolve) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(async () => {
                if (!inputValue) {
                    resolve([]);
                    return;
                }
                const options = await props.loadOptions(inputValue);
                resolve(options);
            }, 500);
        });
    };

    useEffect(() => {
        if (!props.value) {
            setInputValue("");
        }
    }, [props.value])

    const handleChange = (selected: SelectItemsProps | null) => {
        if (selected) {
            setInputValue(selected.label);
            props.onChange(selected);
        } else {
            setInputValue("");
            props.onChange(null);
        }
    };

    const handleBlur = () => {
        if (inputValue && (!props.value || props.value.label !== inputValue)) {
            props.onChange({ label: inputValue, value: inputValue });
        }
    };

    return (
        <Col
            xl={props.xl}
            lg={props.lg}
            md={props.md}
            sm={props.sm}
            xs={props.xs}
            style={{ margin: "6.4px 0px" }}
        >
            <span className="label">{props.label}:</span>
            <AsyncSelect
                isDisabled={props.isDisabled}
                value={props.value || { label: inputValue, value: inputValue }}
                defaultOptions={false}
                cacheOptions={false}
                placeholder={"Não Selecionado"}
                loadOptions={handleLoadOptions}
                onInputChange={(value) => setInputValue(value)}
                onChange={handleChange}
                onBlur={handleBlur}
                noOptionsMessage={() => "Comece a escrever para pesquisar"}
                loadingMessage={() => "A Carregar..."}
                isClearable={true}
                styles={{
                    control: (base: any) => ({
                        ...base,
                        minHeight: 38,
                        fontSize: 13,
                    }),
                }}
                theme={(theme: any) => ({
                    ...theme,
                    borderRadius: 10,
                    colors: {
                        ...theme.colors,
                        primary: "black",
                    },
                })}
            />
        </Col>
    );
}

export default SearchOrTypeSelectComponent;
